import { useCallback, useEffect, useRef } from "react";

function useClickOutSide(
  ref: React.RefObject<HTMLElement>,
  callback: (e?: MouseEvent) => void,
) {
  const cbRef = useRef(callback);
  cbRef.current = callback;

  const handleClick = useCallback((e: MouseEvent) => {
    if (ref.current && !ref.current.contains(e.target as Node)) {
      cbRef.current(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleClick, { capture: true });
    return () => {
      document.removeEventListener("click", handleClick, { capture: true });
    };
  }, [handleClick]);
}

export default useClickOutSide;
